// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setBroadcastMessageValues,
  setBroadcastMessageList,
  setBroadcastMessageListProps,
  setBroadcastValues,
  setBroadcastList,
  setBroadcastPatientList,
  resetBroadcast
} from 'src/store/modules/admin/broadcast'

// constants
import {
  DEFAULT_PAGINATION,
  BROADCAST_LIBRARY_DEFAULT_SORT
} from 'src/constants'

const initialState = {
  categoryList: [],
  messageValues: {},
  messageList: [],
  messageListProps: {
    sort: BROADCAST_LIBRARY_DEFAULT_SORT,
    pagination: {
      ...DEFAULT_PAGINATION,
      pageSize: 1000
    }
  },
  broadcastValues: {},
  broadcastList: [],
  broadcastPatientList: []
}

export default handleActions(
  {
    [setBroadcastMessageValues](state, { payload: messageValues }) {
      return {
        ...state,
        messageValues
      }
    },

    [setBroadcastMessageList](state, { payload: messageList }) {
      return {
        ...state,
        messageList
      }
    },

    [setBroadcastMessageListProps](state, { payload: messageListProps }) {
      return {
        ...state,
        messageListProps
      }
    },

    [setBroadcastValues](state, { payload: broadcastValues }) {
      return {
        ...state,
        broadcastValues
      }
    },

    [setBroadcastList](state, { payload: broadcastList }) {
      return {
        ...state,
        broadcastList
      }
    },

    [setBroadcastPatientList](state, { payload: broadcastPatientList }) {
      return {
        ...state,
        broadcastPatientList
      }
    },

    [resetBroadcast]() {
      return initialState
    }
  },
  initialState
)
